export const colors = {
    /******* Color without number represents the main color and
     *** color with numbers are the lighter versions of the color *********/
    BLUE: "#007dba",
    BLUE1: "#cce5f1",
    BLUE2: "#066da1",
    BLUE3: "#c7d4dd",
    BLUE4: "#e5f2f8",
    WHITE: "#ffffff",
    GREY: "#616161",
    GREY1: "#adadad",
    GREY2: "#f3f4f5",
    GREY3: "#f9fafa",
    GREY4: "#c4c4c4",
    GREEN: "#7fae1b",
    YELLOW: "#fec600",
    BLACK: "#000000",
    CADET: "#57657a",
    PALEAQUA: "#c7d4dd",
    PATTENSBLUE: "#e5f2f8",
    GAINSBORO: "#e0e0e0",
    LIGHTGREY: "#e7e9eb",
    RED: "#f34336",
    RED1: "#c83e38",
    VIOLET: "#9150e4",
}

export const random_colors = [
    "#007dba",
    "#616161",
    "#7fae1b",
    "#fec600",
    "#f34336",
    "#9150e4",
    "#34c0d3",
    "#94a3bf",
    "#b4053f",
    "#43541d",
    "#f16e90",
    "#d0eb5f",
    "#9af5ec",
    "#9fa07a",
    "#10ba01",
    "#0c0854",
    "#772fd7",
    "#df4ca1",
    "#96533b",
    "#307e6d",
    "#36d29b",
    "#6a5e5a",
    "#265d32",
    "#0f2793",
    "#6f0978",
    "#8b7ee5",
    "#14bfea",
    "#1f1c08",
    "#05cc40",
    "#dc8f91",
    "#5101fd",
]
